import React from 'react';

import './index.css';

const DefaultLink = (props) => {

  return (
    <span className="download-link">{props.name ? props.name : 'Download'}</span>
  );
}

export default DefaultLink;